/**
 * Contains all global template props (specific for the current page)
 */
export const globalTemplatePropsContextKey = "globalTemplateProps";
